import React from 'react'
import './../App.css'
import Pagetitle from '../components/pagetitle/Pagetitle'
import Projectstart from '../components/projectstart/Projectstart'
import Projectarea from '../components/projectarea/Projectarea'
export default function Intership() {
  return (
    <div>
      <Pagetitle pagename="Intership" parentpage="Home"/>
      <Projectstart Projecttitle="Internships" projectdescription="If you're a student with an interest in Technical fields such as Web Development, Mobile App Development, Designing, and Digital Marketing, then apply for one of our internship programs." projectbtntext="Apply Now"/>
      <Projectarea projecttitle="We are offering internships in following areas" coursedescription="There is no any place for internship available"/>
    </div>
  )
}
